import * as React from "react";
const SvgFiRrSelling = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-selling_svg__a)">
      <path
        fill="#062147"
        d="M8.433 18.607c.76.762.76 2.023-.013 2.798l-2.199 2.288a.997.997 0 0 1-1.414.028 1 1 0 0 1-.028-1.414L6.035 21H4c-2.206 0-4-1.794-4-4v-2a1 1 0 1 1 2 0v2c0 1.103.897 2 2 2h2.029l-1.25-1.307a1 1 0 0 1 1.442-1.387zM20 3h-2.035l1.256-1.307a1 1 0 0 0-.028-1.414 1 1 0 0 0-1.414.027L15.58 2.594a1.99 1.99 0 0 0-.013 2.798l2.212 2.301a.997.997 0 0 0 1.414.028 1 1 0 0 0 .028-1.414L17.971 5H20c1.103 0 2 .897 2 2v2a1 1 0 1 0 2 0V7c0-2.206-1.794-4-4-4m3.996 12.715v3.555a3 3 0 0 1-1.512 2.604l-3 1.715a3 3 0 0 1-2.977 0l-3-1.715a3 3 0 0 1-1.512-2.604v-3.555c0-1.074.579-2.072 1.512-2.605l3-1.714a3.01 3.01 0 0 1 2.977 0l3 1.714a3.01 3.01 0 0 1 1.512 2.605m-9.262-1.003L18 16.549l3.262-1.834-2.77-1.583a1 1 0 0 0-.496-.131 1 1 0 0 0-.496.131zM17 21.566v-3.285l-3.004-1.689v2.677a1 1 0 0 0 .503.867zm4.996-2.297v-2.672L19 18.282v3.28l2.492-1.424c.311-.178.503-.51.503-.868zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-2.5 1.897a2.62 2.62 0 0 0-2.193-2.61l-3.261-.544a.64.64 0 0 1-.544-.574.625.625 0 0 1 .622-.67H7.5a1 1 0 0 1 .862.494c.182.31.509.506.869.506.763 0 1.253-.825.874-1.487A3 3 0 0 0 7.5 1.999a1 1 0 0 0-2 0h-.315c-1.451 0-2.673 1.152-2.685 2.603a2.62 2.62 0 0 0 2.192 2.61l3.286.548c.315.052.54.331.52.655-.02.334-.315.585-.649.585h-2.35a1 1 0 0 1-.862-.494A1.01 1.01 0 0 0 3.768 8c-.763 0-1.253.825-.874 1.487A3 3 0 0 0 5.499 11a1 1 0 0 0 2 0h.315c1.451 0 2.673-1.152 2.685-2.603z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-selling_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSelling;
